(() => {
  "use strict";

  window.BYL = window.BYL || {};

  const services = BYL.services;
  const customer = BYL.customer;
  const engine = BYL.engine;
  const ui = BYL.ui;

  const CONFIG = window.BYL_CONFIG || {};
  const SHOPIFY_CUSTOMER = CONFIG.customer || {};

  if (
    !services ||
    !customer ||
    !engine ||
    !ui
  ) {
    throw new Error(
      "BYL Core requires services, customer, order engine and UI modules."
    );
  }


  /* =========================================================
     STORAGE
     ========================================================= */

const STORAGE = {
  guestProfiles:
    "byl_guest_profiles_v2",

  pendingProfile:
    "byl_pending_profile_save_v1",

  pendingProfileDelete:
    "byl_pending_profile_delete_v1",

    pendingHistoryDecision:
  "byl_pending_history_decision_v1",

  pendingState:
    "byl_pending_order_state_v1"
};


  /* =========================================================
     STATE
     ========================================================= */

  const state = {
    initialized: false,

    schools: [],
    currentSchoolId: "",
    favoriteSchoolId: "",

    profiles: [],
    currentProfileId: "",

    currentBrandId: "",

    selections:
      engine.selections.create(),

    calendarSelections: {},

    activePeriodId: "",

    history: [],

    existingOrderOverrides:
      new Set(),

    rejectedSchoolIds:
      new Set(),

    pricesLoading: false,
    cartBusy: false,

    pendingProfileSave: false
  };

/* =========================================================
   CUSTOMER ORDER HISTORY
   ========================================================= */

function ingestOrderHistory(incoming) {
  if (!Array.isArray(incoming)) return;

  state.history =
  incoming.filter(
    historyLineIsCurrent
  );

  // History can also contribute legacy profiles.
  rebuildProfiles();

  // Re-render so already-ordered dates are immediately blocked.
  renderAll();
}

function setupOrderHistory() {
  // Catch history that loads AFTER core.js
  document.addEventListener("customerOrdersLoaded", event => {
    const incoming =
      Array.isArray(event?.detail?.orders)
        ? event.detail.orders
        : window.customerOrdersSimplified;

    ingestOrderHistory(incoming);
  });

  // Also support scripts that happen to dispatch on window.
  window.addEventListener("customerOrdersLoaded", event => {
    const incoming =
      Array.isArray(event?.detail?.orders)
        ? event.detail.orders
        : window.customerOrdersSimplified;

    ingestOrderHistory(incoming);
  });

  // Catch history that loaded BEFORE core.js
  if (Array.isArray(window.customerOrdersSimplified)) {
    ingestOrderHistory(window.customerOrdersSimplified);
  }
}
  /* =========================================================
     BASIC HELPERS
     ========================================================= */

  function clean(value) {
    return String(value || "")
      .trim()
      .replace(/\s+/g, " ");
  }


  function normalize(value) {
    return clean(value)
      .toLowerCase();
  }

  function historyLineIsCurrent(
  line
) {
  const cutoff =
    "2026-09-01";

  const props =
    (
      line?.properties &&
      typeof line.properties ===
        "object"
    )
      ? line.properties
      : {};

  const serviceValues = [
    props._BYLServiceDate,
    props.Date
  ];

  for (
    const value
    of serviceValues
  ) {
    const text =
      clean(value);

    const match =
      text.match(
        /^(\d{4}-\d{2})(?:-(\d{2}))?/
      );

    if (!match) {
      continue;
    }

    const comparable =
      match[2]
        ? `${match[1]}-${match[2]}`
        : `${match[1]}-01`;

    return (
      comparable >= cutoff
    );
  }

  const orderDate =
    clean(
      line?.orderDate
    );

  const orderDateMatch =
    orderDate.match(
      /^\d{4}-\d{2}-\d{2}/
    );

  if (orderDateMatch) {
    return (
      orderDateMatch[0] >=
      cutoff
    );
  }

  return false;
}

  function safeParse(
    value,
    fallback
  ) {
    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return fallback;
    }

    if (
      typeof value ===
      "object"
    ) {
      return value;
    }

    try {
      return JSON.parse(value);
    } catch {
      return fallback;
    }
  }


  function currentSchool() {
    return (
      state.schools.find(
        entry =>
          clean(
            entry.school
              ?.schoolId
          ) ===
          clean(
            state.currentSchoolId
          )
      )?.school || null
    );
  }


  function currentProfile() {
    return (
      state.profiles.find(
        profile =>
          clean(profile.id) ===
          clean(
            state.currentProfileId
          )
      ) || null
    );
  }


  function isStaffProfile(
    profile
  ) {
    const memberType = clean(
      profile?.memberType
    ).toLowerCase();

    const classroom = clean(
      profile?.classroom ||
      profile?.teacher ||
      profile?.Teacher
    ).toLowerCase();

    return (
      memberType === "staff" ||
      memberType === "office" ||
      classroom === "staff" ||
      classroom === "office"
    );
  }


  function staffBaseBrandId(
    brand
  ) {
    const brandId = clean(
      brand?.brandId
    ).toLowerCase();

    const brandName = clean(
      brand?.brandName
    ).toLowerCase();

    return brandId.endsWith("-staff")
      ? brandId.slice(0, -6)
      : brandName ===
          "booster juice staff"
        ? "booster-juice"
        : "";
  }


  function isStaffBrand(
    brand
  ) {
    return Boolean(
      staffBaseBrandId(brand)
    );
  }


  function isStaffBoosterBrand(
    brand
  ) {
    return (
      staffBaseBrandId(brand) ===
        "booster-juice" ||
      clean(
        brand?.brandName
      ).toLowerCase() ===
        "booster juice staff"
    );
  }


  function isRegularBoosterBrand(
    brand
  ) {
    const brandId =
      clean(
        brand?.brandId
      ).toLowerCase();

    const brandName =
      clean(
        brand?.brandName
      ).toLowerCase();

    return (
      !isStaffBoosterBrand(
        brand
      ) &&
      (
        brandId ===
          "booster-juice" ||
        brandName ===
          "booster juice"
      )
    );
  }


  /*
    Temporary Blair Rd PS rule. Replace this with
    school/brand eligibility data when that is available.
  */
  function isBlairKindergartenBoosterRestriction(
    school,
    profile,
    brand
  ) {
    if (
      normalize(
        school?.schoolName
      ) !== "blair rd ps" ||
      isStaffProfile(
        profile
      ) ||
      !isRegularBoosterBrand(
        brand
      )
    ) {
      return false;
    }

    const classroom =
      normalize(
        profile?.classroom ||
        profile?.teacher ||
        profile?.Teacher
      );

    return /^k[1-4]\b/.test(
      classroom
    );
  }


  function hydrateStaffBrand(
    school,
    brand
  ) {
    if (
      !isStaffBrand(
        brand
      )
    ) {
      return brand;
    }

    const baseBrandId =
      staffBaseBrandId(brand);

    const regular =
      (school?.brands || [])
        .find(
          candidate =>
            !isStaffBrand(candidate) &&
            clean(
              candidate?.brandId
            ).toLowerCase() ===
              baseBrandId
        );

    if (!regular) {
      return brand;
    }

    const dates =
      Array.isArray(
        brand?.dates
      ) &&
      brand.dates.length
        ? brand.dates
        : regular.dates;

    return {
      ...regular,
      ...brand,
      dates,
      // Inherit service dates, never the student's current/previous menu.
      dateMenus: brand.dateMenus || Object.fromEntries(
        (dates || []).map(date => [date, ["current"]])
      ),
      cutoff:
        brand.cutoff ||
        regular.cutoff
    };
  }


  function hydrateBrandsForProfile(
    school,
    brands
  ) {
    const normalized = normalizeStaffBoosterBrands(brands);
    const normalizedSchool = { ...school, brands: normalized };
    return normalized
      .map(
        brand =>
          hydrateStaffBrand(
            normalizedSchool,
            brand
          )
      );
  }


  function normalizeStaffBoosterBrands(brands) {
    const result = (brands || []).map(brand => ({ ...brand }));
    for (const regular of result.filter(isRegularBoosterBrand)) {
      const staffItems = (regular.items || []).filter(item =>
        /staff/i.test(clean(item.itemName)) && /smoothie/i.test(clean(item.itemName))
      );
      if (!staffItems.length) continue;
      regular.items = regular.items.filter(item => !staffItems.includes(item));
      let staff = result.find(isStaffBoosterBrand);
      if (!staff) {
        staff = { brandId: "booster-juice-staff", brandName: "Booster Juice Staff", items: [] };
        result.push(staff);
      }
      const items = [...(staff.items || [])];
      for (const item of staffItems) {
        if (!items.some(existing => clean(existing.variantId) === clean(item.variantId))) {
          items.push({ ...item, brandId: staff.brandId, brandName: staff.brandName });
        }
      }
      staff.items = items;
    }
    return result;
  }


  function brandsForProfile(
    school,
    profile
  ) {
    const available =
      hydrateBrandsForProfile(
        school,
        school?.brands || []
        )
        .filter(
          brand =>
            !isBlairKindergartenBoosterRestriction(
              school,
              profile,
              brand
            ) &&
            engine.brands
              .availableForProfile(
                brand,
                profile
              )
        );

    if (!isStaffProfile(profile)) {
      return available;
    }

    const staffBaseBrandIds =
      new Set(
        available
          .map(staffBaseBrandId)
          .filter(Boolean)
      );

    return available.filter(
      brand =>
        isStaffBrand(brand) ||
        !staffBaseBrandIds.has(
          clean(
            brand?.brandId
          ).toLowerCase()
        )
    );
  }


  function currentBrand() {
    const school =
      currentSchool();

    const profile =
      currentProfile();

    if (!school || !profile) {
      return null;
    }

    return (
      brandsForProfile(
        school,
        profile
      )
        .find(
          brand =>
            (
              clean(
                brand.brandId
              ) ===
              clean(
                state.currentBrandId
              )
            ) &&
            engine.brands
              .availableForProfile(
                brand,
                profile
              )
        ) || null
    );
  }


  function isLoggedInCustomer() {
    return (
      SHOPIFY_CUSTOMER
        .loggedIn === true
    );
  }


  function profileFullName(
    profile
  ) {
    return clean(
      `${profile?.firstName || ""} ${
        profile?.lastName || ""
      }`
    );
  }


  function createProfileId() {
    if (
      window.crypto
        ?.randomUUID
    ) {
      return `child_${crypto.randomUUID()}`;
    }

    return (
      `child_${Date.now()}_` +
      Math.random()
        .toString(36)
        .slice(2)
    );
  }


  /* =========================================================
     SCHOOL HELPERS
     ========================================================= */

  function normalizeSchoolEntry(
    entry
  ) {
    if (!entry) {
      return null;
    }

    if (entry.school) {
      return {
        school:
          entry.school,

        accessToken:
          clean(
            entry.accessToken
          )
      };
    }

    return {
      school:
        entry,

      accessToken: ""
    };
  }


  function findSchoolEntry(
    schoolId
  ) {
    return (
      state.schools.find(
        entry =>
          clean(
            entry.school
              ?.schoolId
          ) ===
          clean(schoolId)
      ) || null
    );
  }


  function addSchoolEntry(
    result
  ) {
    const normalized =
      normalizeSchoolEntry(
        result
      );

    if (
      !normalized
        ?.school
        ?.schoolId
    ) {
      return;
    }

    const id =
      clean(
        normalized.school
          .schoolId
      );

    const existingIndex =
      state.schools
        .findIndex(
          entry =>
            clean(
              entry.school
                ?.schoolId
            ) === id
        );

    if (existingIndex >= 0) {
      state.schools[
        existingIndex
      ] = normalized;
    } else {
      state.schools.push(
        normalized
      );
    }
  }


  /* =========================================================
     GUEST PROFILES
     ========================================================= */

  function readGuestProfiles() {
    try {
      const parsed =
        safeParse(
          localStorage
            .getItem(
              STORAGE
                .guestProfiles
            ),
          []
        );

      return Array.isArray(parsed)
        ? parsed
        : [];
    } catch {
      return [];
    }
  }


  function writeGuestProfiles(
    profiles
  ) {
    try {
      localStorage.setItem(
        STORAGE.guestProfiles,
        JSON.stringify(
          profiles || []
        )
      );
    } catch (error) {
      console.warn(
        "BYL: Could not save guest profiles.",
        error
      );
    }
  }


  function guestProfilesForSchool(
    school
  ) {
    if (!school) {
      return [];
    }

    return readGuestProfiles()
      .filter(profile => {
        if (
          profile.schoolId &&
          school.schoolId
        ) {
          return (
            clean(
              profile.schoolId
            ) ===
            clean(
              school.schoolId
            )
          );
        }

        return (
          normalize(
            profile.schoolName
          ) ===
          normalize(
            school.schoolName
          )
        );
      })
      .map(
        customer.profiles
          .normalize
      );
  }


  function saveGuestProfile(
    profile
  ) {
    const all =
      readGuestProfiles();

    const normalized =
      customer.profiles
        .normalize({
          ...profile,

          id:
            profile.id ||
            createProfileId()
        });

    const index =
      all.findIndex(
        existing =>
          clean(
            existing.id
          ) ===
          clean(
            normalized.id
          )
      );

    if (index >= 0) {
      all[index] =
        normalized;
    } else {
      all.push(
        normalized
      );
    }

    writeGuestProfiles(all);

    return normalized;
  }


  /* =========================================================
     HISTORY
     ========================================================= */

  function setHistory(
    history
  ) {
    state.history =
  Array.isArray(history)
    ? history.filter(
        historyLineIsCurrent
      )
    : [];

    rebuildProfiles();

    renderProfiles();
    renderOrder();
  }


  function initializeHistory() {
    if (
      Array.isArray(
        window
          .customerOrdersSimplified
      )
    ) {
      setHistory(
        window
          .customerOrdersSimplified
      );
    }

    window.addEventListener(
      "customerOrdersLoaded",
      () => {
        setHistory(
          window
            .customerOrdersSimplified ||
          []
        );
      }
    );
  }


  function historyProfilesForSchool(
    school
  ) {
    if (!school) {
      return [];
    }

    const profiles =
      new Map();

    for (
      const line
      of state.history
    ) {
      const props =
        (
          line?.properties &&
          typeof line
            .properties ===
            "object"
        )
          ? line.properties
          : {};

      const propertySchoolId =
        clean(
          props._schoolId ||
          props._BYLSchoolId
        );

      const propertySchoolName =
        clean(
          props.School
        );

      let schoolMatches =
        false;

      if (
        propertySchoolId &&
        school.schoolId
      ) {
        schoolMatches =
          propertySchoolId ===
          clean(
            school.schoolId
          );
      } else {
        schoolMatches =
          normalize(
            propertySchoolName
          ) ===
          normalize(
            school.schoolName
          );
      }

      if (!schoolMatches) {
        continue;
      }

      const rawName =
        clean(
          props.Name ||
          props.Student ||
          props["Student Name"]
        );

      if (!rawName) {
        continue;
      }

      let firstName = "";
      let lastName = "";

      const nameParts =
        rawName.split(/\s+/);

      firstName =
        nameParts.shift() || "";

      lastName =
        nameParts.join(" ");

      const classroom =
        clean(
          props.Teacher ||
          props.Classroom
        );

      const profileId =
        clean(
          props._BYLProfileId
        );

      const key =
        profileId
          ? `id:${profileId}`
          : (
              `legacy:` +
              `${normalize(rawName)}|` +
              `${normalize(classroom)}`
            );

      if (
        profiles.has(key)
      ) {
        continue;
      }

      const historicalProfile =
  customer.profiles
    .normalize({
      id:
        profileId ||
        `history_${stringHash(
          key
        )}`,

      memberType: [
        "staff",
        "office"
      ].includes(
        normalize(classroom)
      )
        ? normalize(classroom)
        : "student",

      firstName,
      lastName,

      schoolId:
        clean(
          school.schoolId
        ),

      schoolName:
        clean(
          school.schoolName
        ),

      classroom: [
        "staff",
        "office"
      ].includes(
        normalize(classroom)
      )
        ? ""
        : classroom,

      notes:
        clean(
          props.Allergies
        ),

      active: true
    });

historicalProfile.historyKey =
  key;

historicalProfile.source =
  "history";

profiles.set(
  key,
  historicalProfile
);
    }

    return [
      ...profiles.values()
    ];
  }


  function stringHash(
    text
  ) {
    let hash = 0;

    const source =
      String(text || "");

    for (
      let i = 0;
      i < source.length;
      i++
    ) {
      hash =
        (
          (hash << 5) -
          hash +
          source.charCodeAt(i)
        ) | 0;
    }

    return Math.abs(hash)
      .toString(36);
  }


  /* =========================================================
     METAFIELD PROFILES
     ========================================================= */

  function liquidProfilesForSchool(
    school
  ) {
    if (
      !school ||
      !isLoggedInCustomer()
    ) {
      return [];
    }

    const payload =
      customer.profiles
        .initial();

    return (
      payload.children || []
    )
      .filter(
        profile =>
          profile.active !== false
      )
      .filter(profile => {
        if (
          profile.schoolId
        ) {
          return (
            clean(
              profile.schoolId
            ) ===
            clean(
              school.schoolId
            )
          );
        }

        return (
          normalize(
            profile.schoolName
          ) ===
          normalize(
            school.schoolName
          )
        );
      });
  }
function historyDecisions() {
  if (!isLoggedInCustomer()) {
    return [];
  }

  const payload =
    customer.profiles
      .initial();

  return Array.isArray(
    payload.historyDecisions
  )
    ? payload.historyDecisions
    : [];
}

  /* =========================================================
     PROFILE MERGING
     ========================================================= */

function mergeProfiles(
  historyProfiles,
  savedProfiles
) {
  const result =
    new Map();

  const decisions =
    historyDecisions();

  const decisionMap =
    new Map(
      decisions.map(
        decision => [
          clean(
            decision.historyKey
          ),
          decision
        ]
      )
    );

  /*
    Historical profiles remain visible unless
    the customer previously merged or removed them.
  */

  for (
    const profile
    of historyProfiles
  ) {
    const historyKey =
      clean(
        profile.historyKey
      );

    const decision =
      decisionMap.get(
        historyKey
      );

    if (
      decision?.action ===
        "merged" ||
      decision?.action ===
        "hidden"
    ) {
      continue;
    }

    const key =
      historyKey
        ? `history:${historyKey}`
        : `history:${profile.id}`;

    result.set(
      key,
      profile
    );
  }

  /*
    Saved Shopify profiles are always included.
    They are authoritative records and are not
    automatically collapsed with order history.
  */

  for (
    const profile
    of savedProfiles
  ) {
    const normalized =
      customer.profiles
        .normalize(
          profile
        );

    normalized.source =
      "saved";

    const key =
      normalized.id
        ? `saved:${normalized.id}`
        : (
            `saved:` +
            profileMatchKey(
              normalized
            )
          );

    result.set(
      key,
      normalized
    );
  }

  return [
    ...result.values()
  ].filter(
    profile =>
      profile.active !== false
  );
}

function profileReviewPairs() {
  const historical =
    state.profiles.filter(
      profile =>
        profile.source ===
        "history"
    );

  const saved =
    state.profiles.filter(
      profile =>
        profile.source ===
        "saved"
    );

  const decisions =
    historyDecisions();

  const decisionKeys =
    new Set(
      decisions.map(
        decision =>
          clean(
            decision.historyKey
          )
      )
    );

  const pairs = [];

  for (
    const historyProfile
    of historical
  ) {
    const historyKey =
      clean(
        historyProfile
          .historyKey
      );

    if (
      !historyKey ||
      decisionKeys.has(
        historyKey
      )
    ) {
      continue;
    }
const savedProfile =
  saved.find(
    profile => {
      const savedFirst =
        normalize(
          profile.firstName
        );

      const historyFirst =
        normalize(
          historyProfile.firstName
        );

      const savedLast =
        normalize(
          profile.lastName
        );

      const historyLast =
        normalize(
          historyProfile.lastName
        );

      const sameFirstName =
        savedFirst ===
        historyFirst;

      const compatibleLastName =
        !savedLast ||
        !historyLast ||
        savedLast ===
          historyLast ||
        (
          savedLast.length === 1 &&
          historyLast.startsWith(
            savedLast
          )
        ) ||
        (
          historyLast.length === 1 &&
          savedLast.startsWith(
            historyLast
          )
        );

      const sameMemberType =
        normalize(
          profile.memberType
        ) ===
        normalize(
          historyProfile.memberType
        );

      return (
        sameFirstName &&
        compatibleLastName &&
        sameMemberType
      );
    }
  );

    if (!savedProfile) {
      continue;
    }

    pairs.push({
      historyProfile,
      savedProfile,
      historyKey
    });
  }

  return pairs;
}
  function profileMatchKey(
    profile
  ) {
    return [
      normalize(
        profile.firstName
      ),

      normalize(
        profile.lastName
      ),

      normalize(
        profile.classroom
      ),

      normalize(
        profile.memberType
      )
    ].join("|");
  }


  function rebuildProfiles() {
    const school =
      currentSchool();

    if (!school) {
      state.profiles = [];
      state.currentProfileId = "";
      return;
    }

    const historical =
      historyProfilesForSchool(
        school
      );

    const saved =
      isLoggedInCustomer()
        ? liquidProfilesForSchool(
            school
          )
        : guestProfilesForSchool(
            school
          );

    state.profiles =
      mergeProfiles(
        historical,
        saved
      );

    if (
      state.currentProfileId &&
      !state.profiles.some(
        profile =>
          profile.id ===
          state.currentProfileId
      )
    ) {
      state.currentProfileId =
        "";
    }
  }


  /* =========================================================
     PENDING OAUTH STATE
     ========================================================= */

  function savePendingState() {
    const snapshot = {
      currentSchoolId:
        state.currentSchoolId,

      currentProfileId:
        state.currentProfileId,

      currentBrandId:
        state.currentBrandId,

      selections:
        state.selections,

      activePeriodId:
        state.activePeriodId,

      overrides: [
        ...state
          .existingOrderOverrides
      ]
    };

    try {
      sessionStorage.setItem(
        STORAGE.pendingState,
        JSON.stringify(snapshot)
      );
    } catch {
      // no-op
    }
  }


  function readPendingState() {
    try {
      const raw =
        sessionStorage.getItem(
          STORAGE.pendingState
        );

      if (!raw) {
        return null;
      }

      return safeParse(
        raw,
        null
      );
    } catch {
      return null;
    }
  }


  function clearPendingState() {
    try {
      sessionStorage.removeItem(
        STORAGE.pendingState
      );
    } catch {
      // no-op
    }
  }


  function restorePendingState(
    snapshot
  ) {
    if (!snapshot) {
      return;
    }

    if (
      snapshot.currentSchoolId &&
      findSchoolEntry(
        snapshot
          .currentSchoolId
      )
    ) {
      state.currentSchoolId =
        snapshot.currentSchoolId;
    }

    rebuildProfiles();

    if (
      snapshot.currentProfileId &&
      state.profiles.some(
        profile =>
          profile.id ===
          snapshot
            .currentProfileId
      )
    ) {
      state.currentProfileId =
        snapshot
          .currentProfileId;
    }

    const school =
      currentSchool();

    if (
      snapshot.currentBrandId &&
      school?.brands?.some(
        brand =>
          brand.brandId ===
          snapshot
            .currentBrandId
      )
    ) {
      state.currentBrandId =
        snapshot
          .currentBrandId;
    }

    state.selections =
      engine.selections
        .ensure(
          snapshot.selections
        );

    state.activePeriodId =
      clean(
        snapshot
          .activePeriodId
      );

    state.existingOrderOverrides =
      new Set(
        snapshot.overrides || []
      );
  }


  function savePendingProfile(
    profile
  ) {
    try {
      sessionStorage.setItem(
        STORAGE.pendingProfile,
        JSON.stringify(
          profile
        )
      );
    } catch {
      // no-op
    }
  }


  function readPendingProfile() {
    try {
      return safeParse(
        sessionStorage.getItem(
          STORAGE.pendingProfile
        ),
        null
      );
    } catch {
      return null;
    }
  }


  function clearPendingProfile() {
    try {
      sessionStorage.removeItem(
        STORAGE.pendingProfile
      );
    } catch {
      // no-op
    }
  }
function savePendingProfileDelete(
  profile
) {
  try {
    sessionStorage.setItem(
      STORAGE.pendingProfileDelete,
      JSON.stringify(
        profile
      )
    );
  } catch {
    // no-op
  }
}


function readPendingProfileDelete() {
  try {
    return safeParse(
      sessionStorage.getItem(
        STORAGE.pendingProfileDelete
      ),
      null
    );
  } catch {
    return null;
  }
}


function clearPendingProfileDelete() {
  try {
    sessionStorage.removeItem(
      STORAGE.pendingProfileDelete
    );
  } catch {
    // no-op
  }
}
function savePendingHistoryDecision(
  decision
) {
  try {
    sessionStorage.setItem(
      STORAGE.pendingHistoryDecision,
      JSON.stringify(
        decision
      )
    );
  } catch {
    // no-op
  }
}


function readPendingHistoryDecision() {
  try {
    return safeParse(
      sessionStorage.getItem(
        STORAGE.pendingHistoryDecision
      ),
      null
    );
  } catch {
    return null;
  }
}


function clearPendingHistoryDecision() {
  try {
    sessionStorage.removeItem(
      STORAGE.pendingHistoryDecision
    );
  } catch {
    // no-op
  }
}
  /* =========================================================
     RENDER
     ========================================================= */

  function renderSchools() {
    const school =
      currentSchool();

    if (!school) {
      ui.school.showGate();
      return;
    }

    ui.school.hideGate();

    ui.school.render({
      schools:
        state.schools,

      currentSchool:
        school,

      favoriteSchoolId:
        state.favoriteSchoolId
    });
  }


function renderProfiles() {
  const school =
    currentSchool();

  if (!school) {
    return;
  }

  ui.profiles.render({
    profiles:
      state.profiles,

    currentProfileId:
      state.currentProfileId,

    reviewPairs:
      profileReviewPairs()
  });
}


  function renderBrands() {
    const school =
      currentSchool();

    const profile =
      currentProfile();

    if (
      !school ||
      !profile
    ) {
      return;
    }

    ui.brands.render({
      brands:
        brandsForProfile(
          school,
          profile
        ),

      currentBrandId:
        state.currentBrandId
    });
  }


  function renderOrder({ changedDate = "", optionsOnly = false } = {}) {
    const school =
      currentSchool();

    const profile =
      currentProfile();

    const brand =
      currentBrand();

    if (
      !school ||
      !profile ||
      !brand
    ) {
      ui.order.reset();
      return;
    }

    ui.order.render({
      changedDate,
      optionsOnly,
      school,
      profile,
      brand,

      selections:
        state.selections,

      history:
        state.history,

      overrides:
        state
          .existingOrderOverrides,

      activePeriodId:
        state.activePeriodId
    });
  }


  function renderSummary() {
    const brand =
      currentBrand();

    if (!brand) {
      return;
    }

    ui.order.summary({
      brand,

      selections:
        state.selections,

      activePeriodId:
        state.activePeriodId,

      cartBusy:
        state.cartBusy
    });
  }


  function renderAll() {
    renderSchools();
    renderProfiles();

    if (
      state.currentProfileId
    ) {
      renderBrands();
    }

    renderOrder();
  }


  /* =========================================================
     SCHOOL ACCESS
     ========================================================= */

  async function unlockSchool(
    code
  ) {
    ui.loading.set(
      true,
      "Checking school code..."
    );

    try {
      const result =
        await services
          .schools
          .unlock(code);

      addSchoolEntry(
  result
);

if (
  isLoggedInCustomer() &&
  customer.auth
    .isAuthenticated()
) {
  await customer.schools
    .saveAccess({
      ...result.school,

      accessToken:
        result.accessToken
    });
}

selectSchool(
  result.school
    .schoolId
);

      closeAddSchoolModal();

    } catch (error) {
      console.error(
        "BYL school unlock:",
        error
      );

      ui.school.gateError(
        friendlyError(
          error,
          "That school code could not be verified."
        )
      );
    } finally {
      ui.loading.set(false);
    }
  }


async function restoreSchools() {
  ui.loading.set(
    true,
    "Loading your school..."
  );

  try {
    const restoredBrowser =
      await services
        .schools
        .restoreStored();

    state.schools =
      restoredBrowser
        .map(
          normalizeSchoolEntry
        )
        .filter(Boolean);

    /*
      Logged-in customers may also have
      verified schools stored in Shopify.

      Never trust the saved school name/config
      itself. Re-validate the signed accessToken
      through AWS and load the current school data.
    */
    if (
      isLoggedInCustomer()
    ) {
      const saved =
        customer.schools
          .initial();

      for (
        const entry of
        saved.schools || []
      ) {
        if (
          findSchoolEntry(
            entry.schoolId
          )
        ) {
          continue;
        }

        try {
          const restored =
            await services
              .schools
              .restore(
                entry.accessToken
              );

          addSchoolEntry(
            restored
          );

} catch (error) {
  console.warn(
    "BYL saved Shopify school rejected:",
    entry.schoolId,
    error
  );

  state.rejectedSchoolIds.add(
  entry.schoolId
);

  try {
    if (
      customer.auth
        .isAuthenticated()
    ) {
      await customer.schools
        .removeAccess(
          entry.schoolId
        );
    } else {
      console.warn(
        "BYL rejected school cleanup deferred until customer authorization:",
        entry.schoolId
      );
    }

  } catch (removeError) {
    console.warn(
      "BYL could not remove rejected saved school:",
      entry.schoolId,
      removeError
    );
  }
}
      }
    }

  } catch (error) {
    console.warn(
      "BYL school restore:",
      error
    );

    state.schools = [];

  } finally {
    ui.loading.set(false);
  }
}


  function selectSchool(
    schoolId
  ) {
    const entry =
      findSchoolEntry(
        schoolId
      );

    if (!entry) {
      return;
    }

    state.currentSchoolId =
      entry.school
        .schoolId;

    state.currentProfileId =
      "";

    state.currentBrandId =
      "";

    state.selections =
      engine.selections
        .create();

    state.activePeriodId =
      "";

    state.existingOrderOverrides
      .clear();

    rebuildProfiles();

    ui.resetAfterSchoolChange();

    renderSchools();
    renderProfiles();
  }


  async function favoriteSchool(
    schoolId
  ) {
    const entry =
      findSchoolEntry(
        schoolId
      );

    if (!entry) {
      return;
    }

    state.favoriteSchoolId =
      entry.school.schoolId;

    state.schools = [
      entry,
      ...state.schools.filter(
        item =>
          clean(
            item.school?.schoolId
          ) !==
          clean(schoolId)
      )
    ];

    services.schools
      .prioritizeStored?.(
        schoolId
      );

    renderSchools();

    try {
      if (
        isLoggedInCustomer() &&
        customer.auth
          .isAuthenticated()
      ) {
        await customer.schools
          .saveAccess({
            ...entry.school,

            accessToken:
              entry.accessToken
          },
          {
            makeDefault:
              false
          });

        await customer.schools
          .setDefault?.(
            entry.school.schoolId
          );
      }

      ui.messages.set(
        `${entry.school.schoolName || "School"} is now your favorite school.`,
        "success"
      );

    } catch (error) {
      console.warn(
        "BYL favorite school save:",
        error
      );

      ui.messages.set(
        "That school was favorited on this device, but could not be saved to your account.",
        "info"
      );
    }
  }


  async function deleteSchool(
    schoolId
  ) {
    const id =
      clean(schoolId);

    const entry =
      findSchoolEntry(id);

    if (!entry) {
      return;
    }

    services.schools
      .removeStored?.(id);

    state.schools =
      state.schools.filter(
        item =>
          clean(
            item.school?.schoolId
          ) !== id
      );

    if (
      state.favoriteSchoolId === id
    ) {
      state.favoriteSchoolId =
        state.schools[0]
          ?.school
          ?.schoolId || "";
    }

    if (
      state.currentSchoolId === id
    ) {
      state.currentSchoolId =
        state.favoriteSchoolId ||
        state.schools[0]
          ?.school
          ?.schoolId ||
        "";

      state.currentProfileId =
        "";

      state.currentBrandId =
        "";

      state.selections =
        engine.selections
          .create();

      state.activePeriodId =
        "";

      state.existingOrderOverrides
        .clear();
    }

    rebuildProfiles();
    ui.resetAfterSchoolChange();

    if (!state.currentSchoolId) {
      renderSchools();
      ui.school.showGate();
      hideUnavailableAfterSchoolDelete();
    } else {
      renderSchools();
      renderProfiles();
      renderOrder();
    }

    try {
      if (
        isLoggedInCustomer() &&
        customer.auth
          .isAuthenticated()
      ) {
        await customer.schools
          .removeAccess(id);
      }

      ui.messages.set(
        `${entry.school.schoolName || "School"} was removed.`,
        "success"
      );

    } catch (error) {
      console.warn(
        "BYL school remove:",
        error
      );

      ui.messages.set(
        "The school was removed on this device, but could not be removed from your account.",
        "info"
      );
    }
  }


  function hideUnavailableAfterSchoolDelete() {
    ui.order.reset();
  }


  /* =========================================================
     ADD SCHOOL MODAL
     ========================================================= */

  function findAddSchoolModal() {
    return (
      document.getElementById(
        "byl-school-modal"
      ) ||
      document.getElementById(
        "byl-add-school-modal"
      )
    );
  }


  function findModalCodeInput(
    modal
  ) {
    return (
      modal?.querySelector(
        "#byl-modal-school-code"
      ) ||
      modal?.querySelector(
        "[data-byl-school-code]"
      ) ||
      modal?.querySelector(
        'input[type="text"]'
      )
    );
  }


  function findModalSubmit(
    modal
  ) {
    return (
      modal?.querySelector(
        "#byl-modal-school-submit"
      ) ||
      modal?.querySelector(
        "[data-byl-school-submit]"
      ) ||
      modal?.querySelector(
        'button[type="submit"]'
      )
    );
  }


  let addSchoolModalBound =
    false;


  function openAddSchoolModal() {
    const modal =
      findAddSchoolModal();

    if (!modal) {
      ui.school.showGate();
      return;
    }

    modal.hidden = false;
    modal.classList.remove(
      "hidden"
    );

    modal.setAttribute(
      "aria-hidden",
      "false"
    );

    const input =
      findModalCodeInput(
        modal
      );

    input?.focus();

    if (
      addSchoolModalBound
    ) {
      return;
    }

    addSchoolModalBound =
      true;

    const submit =
      findModalSubmit(
        modal
      );

    submit
      ?.addEventListener(
        "click",
        event => {
          event.preventDefault();

          const code =
            clean(
              findModalCodeInput(
                modal
              )?.value
            );

          if (code) {
            unlockSchool(code);
          }
        }
      );

    input
      ?.addEventListener(
        "keydown",
        event => {
          if (
            event.key ===
            "Enter"
          ) {
            event.preventDefault();

            const code =
              clean(
                input.value
              );

            if (code) {
              unlockSchool(
                code
              );
            }
          }
        }
      );

    modal
      .querySelectorAll(
        "[data-byl-modal-close], .byl-modal-close"
      )
      .forEach(button => {
        button.addEventListener(
          "click",
          closeAddSchoolModal
        );
      });
  }


  function closeAddSchoolModal() {
    const modal =
      findAddSchoolModal();

    if (!modal) {
      return;
    }

    modal.hidden = true;
    modal.classList.add(
      "hidden"
    );

    modal.setAttribute(
      "aria-hidden",
      "true"
    );

    const input =
      findModalCodeInput(
        modal
      );

    if (input) {
      input.value = "";
    }

    modal
      .querySelectorAll(
        ".byl-field-error, [role='alert']"
      )
      .forEach(element => {
        element.textContent = "";
        element.classList.add(
          "hidden"
        );
      });
  }


  /* =========================================================
     PROFILE EDITING
     ========================================================= */

  function openProfileEditor(
    profile
  ) {
    const school =
      currentSchool();

    if (!school) {
      return;
    }

    ui.profiles.openEditor({
      profile,
      teachers:
        school.teachers || []
    });
  }


  function prepareProfileForSchool(
    profile
  ) {
    const school =
      currentSchool();

    return {
      ...profile,

      id:
        profile.id ||
        createProfileId(),

      schoolId:
        clean(
          school?.schoolId
        ),

      schoolName:
        clean(
          school?.schoolName
        )
    };
  }


  async function saveProfile(
    rawProfile
  ) {
    const profile =
      prepareProfileForSchool(
        rawProfile
      );

    if (
      !isLoggedInCustomer()
    ) {
      const saved =
        saveGuestProfile(
          profile
        );

      rebuildProfiles();

      state.currentProfileId =
        saved.id;

      ui.profiles.closeEditor();

      renderProfiles();
      renderBrands();
      renderOrder();

      return;
    }

    /*
      Logged-in customers are saved to
      Shopify customer metafields.

      If Customer Account API auth has not
      happened in this tab yet, preserve the
      action and the ordering state before
      starting PKCE.
    */

    if (
      !customer.auth
        .isAuthenticated()
    ) {
      savePendingProfile(
        profile
      );

      savePendingState();

      state.pendingProfileSave =
        true;

      ui.loading.set(
        true,
        "Connecting your customer account..."
      );

      try {
        await customer.auth
          .begin({
            prompt: "none",
            returnTo:
              window.location.href
          });
      } catch (error) {
        ui.loading.set(false);

        console.error(
          "BYL customer auth:",
          error
        );

        alert(
          friendlyError(
            error,
            "Your customer account could not be connected."
          )
        );
      }

      return;
    }

    await saveProfileToShopify(
      profile
    );
  }


  async function saveProfileToShopify(
    profile
  ) {
    ui.loading.set(
      true,
      "Saving profile..."
    );

    try {
      /*
        Load the latest metafield from Shopify
        first. customer.upsert then merges the
        profile into the full children array so
        children from other schools are kept.
      */

      await customer.api
        .loadCustomer({
          forceRefresh: true
        });

      const result =
        await customer.profiles
          .upsert(profile);

      const savedProfile =
        result.profile;

      /*
        Update the Liquid-side source object for
        this browser session. This avoids needing
        another full page refresh merely to see
        the newly saved profile.
      */

      const currentPayload =
        customer.profiles
          .initial();

      const children =
        [
          ...(
            currentPayload
              .children || []
          )
        ];

      const index =
        children.findIndex(
          child =>
            child.id ===
            savedProfile.id
        );

      if (index >= 0) {
        children[index] =
          savedProfile;
      } else {
        children.push(
          savedProfile
        );
      }

      const existingStudents =
  customer.profiles
    .initial();

SHOPIFY_CUSTOMER.students = {
  children,

  historyDecisions:
    Array.isArray(
      existingStudents
        ?.historyDecisions
    )
      ? existingStudents
          .historyDecisions
      : [],

  savedAt:
    new Date()
      .toISOString()
};

      rebuildProfiles();

      state.currentProfileId =
        savedProfile.id;

      ui.profiles.closeEditor();

      renderProfiles();
      renderBrands();
      renderOrder();

      clearPendingProfile();
      clearPendingState();

    } catch (error) {
      console.error(
        "BYL profile save:",
        error
      );

      if (
        error?.code ===
          "AUTH_REQUIRED" ||
        error?.code ===
          "AUTH_EXPIRED"
      ) {
        savePendingProfile(
          profile
        );

        savePendingState();

        customer.auth.clear();

        try {
          await customer.auth
            .begin({
              returnTo:
                window.location.href
            });

          return;
        } catch (
          authError
        ) {
          console.error(
            "BYL profile re-auth:",
            authError
          );
        }
      }

      alert(
        friendlyError(
          error,
          "The profile could not be saved."
        )
      );
    } finally {
      ui.loading.set(false);
    }
  }
  async function deleteProfile(
  profile
) {
  if (
    !profile ||
    !profile.id
  ) {
    return;
  }

  const name =
    profileFullName(profile) ||
    "this profile";

  const confirmed =
    window.confirm(
      `Remove ${name}?`
    );

  if (!confirmed) {
    return;
  }

  /*
    Historical-only profiles aren't stored
    as Shopify child profiles, so we'll deal
    with those separately later.
  */
 if (
  profile.source ===
  "history"
) {
  ui.messages.set(
    "This older profile can't be deleted here yet.",
    "info"
  );

  return;
}

if (
  !customer.auth
    .isAuthenticated()
) {
  savePendingProfileDelete(
    profile
  );

  savePendingState();

  ui.loading.set(
    true,
    "Connecting your customer account..."
  );

  try {
    await customer.auth
      .begin({
        prompt: "none",
        returnTo:
          window.location.href
      });

    return;

  } catch (error) {
    console.error(
      "BYL profile delete auth:",
      error
    );

    ui.loading.set(false);

    ui.messages.set(
      friendlyError(
        error,
        "Your customer account could not be connected."
      ),
      "error"
    );

    return;
  }
}

ui.loading.set(
  true,
  "Removing profile..."
);

  try {
    await customer.api
      .loadCustomer({
        forceRefresh: true
      });

const result =
  await customer.profiles
    .deactivate(
      profile.id
    );

/*
  Also hide any historical profile created
  from orders carrying this same profile ID.
*/
const historyResult =
  await customer.profiles
    .historyDecision({
      historyKey:
        `id:${profile.id}`,

      action:
        "hidden",

      profileId:
        profile.id
    });

const students =
  historyResult.students ||
  result;

SHOPIFY_CUSTOMER.students = {
  children:
    students.children || [],

  historyDecisions:
    students.historyDecisions ||
    [],

  savedAt:
    students.savedAt ||
    new Date()
      .toISOString()
};

    if (
      clean(
        state.currentProfileId
      ) ===
      clean(profile.id)
    ) {
      state.currentProfileId =
        "";

      state.currentBrandId =
        "";

      state.selections =
        engine.selections
          .create();

      state.activePeriodId =
        "";
    }

    rebuildProfiles();

    renderProfiles();
    renderBrands();
    renderOrder();

    ui.messages.set(
      `${name} was removed.`,
      "success"
    );

  } catch (error) {
    console.error(
      "BYL profile delete:",
      error
    );

    ui.messages.set(
      friendlyError(
        error,
        "The profile could not be removed."
      ),
      "error"
    );

  } finally {
    ui.loading.set(false);
  }
}
async function saveProfileHistoryDecision({
  action,
  historyKey,
  savedProfile
} = {}) {
  const normalizedAction =
    clean(action);

  const normalizedHistoryKey =
    clean(historyKey);

  if (
    !normalizedHistoryKey ||
    ![
      "merged",
      "hidden",
      "keep"
    ].includes(
      normalizedAction
    )
  ) {
    return;
  }

 if (
  !customer.auth
    .isAuthenticated()
) {
  savePendingHistoryDecision({
    action:
      normalizedAction,

    historyKey:
      normalizedHistoryKey,

    savedProfile:
      savedProfile || null
  });

  savePendingState();

  try {
    await customer.auth
      .begin({
        prompt: "none",
        returnTo:
          window.location.href
      });
  } catch (error) {
    console.error(
      "BYL profile history auth:",
      error
    );

    ui.messages.set(
      friendlyError(
        error,
        "Your customer account could not be connected."
      ),
      "error"
    );
  }

  return;
}
  try {
    ui.loading.set(
      true,
      "Saving profile choice..."
    );

    const result =
      await customer.profiles
        .historyDecision({
          historyKey:
            normalizedHistoryKey,

          action:
            normalizedAction,

          profileId:
            normalizedAction ===
              "merged"
              ? clean(
                  savedProfile?.id
                )
              : ""
        });

    /*
      Keep the Liquid/config copy in sync too.

      historyDecisions() reads from
      customer.profiles.initial(), so this
      makes the decision take effect immediately
      without requiring a page refresh.
    */

    if (result?.students) {
      SHOPIFY_CUSTOMER.students =
        result.students;
    }

    rebuildProfiles();

    if (
      normalizedAction ===
        "merged" &&
      savedProfile?.id
    ) {
      state.currentProfileId =
        savedProfile.id;
    }

    renderProfiles();
    renderBrands();
    renderOrder();

  } catch (error) {
    ui.messages.set(
      error?.message ||
        "We couldn't save that profile choice.",
      "error"
    );

  } finally {
    ui.loading.set(
      false
    );
  }
}

  /* =========================================================
     CUSTOMER AUTH CALLBACK
     ========================================================= */

  async function handleCustomerAuth() {
    const url =
      new URL(
        window.location.href
      );

    const hasAuthResult =
      url.searchParams.has(
        "code"
      ) ||
      url.searchParams.has(
        "error"
      );

    if (!hasAuthResult) {
      return;
    }

    ui.loading.set(
      true,
      "Connecting your customer account..."
    );

    try {
      await customer.auth
        .handleCallback();

    } catch (error) {
      console.warn(
        "BYL auth callback:",
        error
      );

      /*
        Silent auth may return login_required.
        In that case, move directly to Shopify's
        normal interactive account authorization.
      */

      if (
        error?.code ===
        "LOGIN_REQUIRED"
      ) {
        try {
          await customer.auth
            .begin({
              returnTo:
                window.location.href
            });

          return;
        } catch (
          loginError
        ) {
          console.error(
            "BYL interactive auth:",
            loginError
          );
        }
      } else {
        alert(
          friendlyError(
            error,
            "Your Shopify customer account could not be connected."
          )
        );
      }
    } finally {
      ui.loading.set(false);
    }
  }


  async function finishPendingProfileSave() {
    const pending =
      readPendingProfile();

    if (
      !pending ||
      !customer.auth
        .isAuthenticated()
    ) {
      return;
    }

    await saveProfileToShopify(
      pending
    );
  }
async function finishPendingProfileDelete() {
  const pending =
    readPendingProfileDelete();

  if (
    !pending ||
    !customer.auth
      .isAuthenticated()
  ) {
    return;
  }

  clearPendingProfileDelete();

  await deleteProfile(
    pending
  );
}
async function finishPendingHistoryDecision() {
  const pending =
    readPendingHistoryDecision();

  if (
    !pending ||
    !customer.auth
      .isAuthenticated()
  ) {
    return;
  }

  clearPendingHistoryDecision();

  await saveProfileHistoryDecision(
    pending
  );
}
  async function syncVerifiedSchoolsToCustomer() {
  if (
    !isLoggedInCustomer() ||
    !customer.auth
      .isAuthenticated()
  ) {
    return;
  }

  /*
    First remove any Shopify-saved schools
    whose signed AWS token failed validation.
  */
  for (
    const schoolId of
    state.rejectedSchoolIds
  ) {
    try {
      await customer.schools
        .removeAccess(
          schoolId
        );

      state.rejectedSchoolIds
        .delete(
          schoolId
        );

    } catch (error) {
      console.warn(
        "BYL rejected school cleanup:",
        schoolId,
        error
      );
    }
  }

  /*
    Then sync only schools that successfully
    restored or were validly unlocked.
  */
  for (
    const entry of
    state.schools
  ) {
    const school =
      entry?.school;

    const accessToken =
      clean(
        entry?.accessToken
      );

    if (
      !school?.schoolId ||
      !accessToken ||
      state.rejectedSchoolIds
        .has(
          school.schoolId
        )
    ) {
      continue;
    }

    try {
      await customer.schools
        .saveAccess({
          ...school,
          accessToken
        },
        {
          makeDefault:
            false
        });

    } catch (error) {
      console.warn(
        "BYL school sync:",
        school.schoolId,
        error
      );
    }
  }

  if (
    state.favoriteSchoolId &&
    findSchoolEntry(
      state.favoriteSchoolId
    )
  ) {
    try {
      await customer.schools
        .setDefault?.(
          state.favoriteSchoolId
        );

    } catch (error) {
      console.warn(
        "BYL school default sync:",
        state.favoriteSchoolId,
        error
      );
    }
  }
}

  /* =========================================================
     PROFILE SELECTION
     ========================================================= */

  function selectProfile(
    profileId
  ) {
    const profile =
      state.profiles.find(
        item =>
          item.id ===
          profileId
      );

    if (!profile) {
      return;
    }

    state.currentProfileId =
      profile.id;

    state.currentBrandId =
      "";

    state.selections =
      engine.selections
        .create();

    state.activePeriodId =
      "";

    state.existingOrderOverrides
      .clear();

    renderProfiles();
    renderBrands();
    renderOrder();
  }


  /* =========================================================
     BRAND SELECTION
     ========================================================= */

  async function selectBrand(
    brandId
  ) {
    const school =
      currentSchool();

    const profile =
      currentProfile();

    const brand =
      school?.brands
        ?.find(
          item =>
            item.brandId ===
            brandId
        );

    if (
      !brand ||
      !profile ||
      !engine.brands
        .availableForProfile(
          brand,
          profile
        )
    ) {
      return;
    }

    state.currentBrandId =
      brandId;

    state.selections =
      engine.selections
        .create();

    state.existingOrderOverrides
      .clear();

    const mode =
      engine.brands
        .getOrderMode(
          brand
        );

    if (
      mode ===
      engine.ORDER_MODES
        .MONTHLY_WEEKDAYS
    ) {
      state.activePeriodId =
        engine.cutoffs
          .openPeriods(
            brand
          )[0]
          ?.periodId || "";
    } else {
      state.activePeriodId =
        "";
    }

    renderBrands();

    /*
      Render immediately, then prices update
      as soon as Shopify variant data arrives.
    */

    renderOrder();

    state.pricesLoading =
      true;

    try {
      await engine.brands
        .preloadVariants(
          brand
        );
    } catch (error) {
      console.warn(
        "BYL variant preload:",
        error
      );
    } finally {
      state.pricesLoading =
        false;

      renderOrder();
    }
  }


  /* =========================================================
     ORDER SELECTION CALLBACKS
     ========================================================= */


  function selectMain(
    date,
    item
  ) {
    state.selections =
      engine.selections
        .setMain(
          state.selections,
          date,
          item
        );

    renderOrder({ changedDate: date });
  }


  function toggleAddOn(
    date,
    item
  ) {
    state.selections =
      engine.selections
        .toggleAddOn(
          state.selections,
          date,
          item
        );

    renderOrder({ changedDate: date });
  }


  function toggleTopping(
  topping
) {
    state.selections =
      engine.selections
        .toggleTopping(
          state.selections,
          topping
        );

    renderOrder({ optionsOnly: true });
  }


  function changeOption(
    group,
    value
  ) {
    state.selections =
      engine.selections
        .setOption(
          state.selections,
          group,
          value
        );

    renderOrder({ optionsOnly: true });
  }


  function changeCustomInput(
    date,
    property,
    value
  ) {
    state.selections =
      engine.selections
        .setCustomInput(
          state.selections,
          date,
          property,
          value
        );
  }


  function changePeriod(
    periodId
  ) {
    state.activePeriodId =
      periodId;

    renderOrder();
  }


  function changePeriodChoice(
    periodId,
    label,
    choice
  ) {
    state.selections =
      engine.selections
        .setPeriodChoice(
          state.selections,
          periodId,
          label,
          choice
        );

    renderOrder();
  }


  function allowExistingOrder(
    date
  ) {
    state
      .existingOrderOverrides
      .add(date);

    renderOrder();
  }


  function copyDateForward(
    sourceDate
  ) {
    const school =
      currentSchool();

    const profile =
      currentProfile();

    const brand =
      currentBrand();

    const source =
      state.selections
        ?.dates
        ?.[sourceDate];

    if (
      !school ||
      !profile ||
      !brand ||
      !source?.variantId
    ) {
      return;
    }

    const dates =
      engine.cutoffs
        .openDates(
          brand
        );

    const next =
      engine.selections
        .ensure(
          state.selections
        );

    let copied = 0;

    for (
      const date
      of dates
    ) {
      if (String(date) <= String(sourceDate)) {
        continue;
      }

      if (!engine.selections.availableForDate(brand, source, profile, date)) {
        continue;
      }

      if (
        next.dates
          ?.[date]
          ?.variantId
      ) {
        continue;
      }

      const existing =
        engine.history
          .findExisting({
            orders:
              state.history,

            profile,

            school,

            brand,

            serviceDate:
              date
          });

      if (
        existing &&
        !state.existingOrderOverrides
          .has(date)
      ) {
        continue;
      }

      next.dates[date] =
        JSON.parse(
          JSON.stringify({
            ...source,
            date
          })
        );

      copied += 1;
    }

    state.selections =
      next;

    renderOrder();

    ui.messages.set(
      copied
        ? `Copied this lunch to ${copied} future date${copied === 1 ? "" : "s"}.`
        : "There are no future dates available with this menu choice.",
      copied
        ? "success"
        : "info"
    );
  }


  /* =========================================================
     CALENDAR ORDER SELECTIONS
     ========================================================= */

  function calendarBrands() {
    const school =
      currentSchool();

    const profile =
      currentProfile();

    if (!school || !profile) {
      return [];
    }

    return (
      brandsForProfile(
        school,
        profile
      )
    ).filter(
      brand =>
        brand?.active !== false &&
        engine.brands
          .getOrderMode(
            brand
          ) !==
          engine.ORDER_MODES
            .MONTHLY_WEEKDAYS
    );
  }


  function calendarSelectionForBrand(
    brandId
  ) {
    const id =
      clean(brandId);

    if (!id) {
      return engine.selections
        .create();
    }

    if (
      !state
        .calendarSelections[
          id
        ]
    ) {
      state.calendarSelections[
        id
      ] =
        engine.selections
          .create();
    }

    return state
      .calendarSelections[
        id
      ];
  }


  function setCalendarSelection(
    brandId,
    selections
  ) {
    const id =
      clean(brandId);

    if (!id) {
      return;
    }

    state.calendarSelections[
      id
    ] =
      engine.selections
        .ensure(
          selections
        );
  }


  function renderCalendarOrdering({ changedBrandId = "", changedDate = "" } = {}) {
    const school =
      currentSchool();

    const profile =
      currentProfile();

    if (
      !school ||
      !profile
    ) {
      return;
    }

    ui.calendar.render({
      changedBrandId,
      changedDate,
      school,

      profile,

      brands:
        calendarBrands(),

      history:
        state.history,

      overrides:
        state
          .existingOrderOverrides,

      selections:
        state.calendarSelections,

      cartBusy:
        state.cartBusy
    });
  }


  function validateCalendarOrder() {
    const school =
      currentSchool();

    const profile =
      currentProfile();

    if (!school) {
      return {
        valid: false,
        error:
          "Choose a school."
      };
    }

    if (!profile) {
      return {
        valid: false,
        error:
          "Choose who this order is for."
      };
    }

    const items = [];

    for (
      const brand
      of calendarBrands()
    ) {
      const selections =
        engine.selections
          .ensure(
            state.calendarSelections[
              brand.brandId
            ]
          );

      const invalidDates = engine.selections.invalidDates({ brand, profile, selections });
      if (invalidDates.length) {
        return {
          valid: false,
          error: `The menu has changed for ${engine.helpers.formatDate(invalidDates[0])}. Please reselect your lunch.`
        };
      }

      const built =
        engine.cart.build({
          school,
          profile,
          brand,
          selections
        });

      items.push(
        ...built
      );
    }

    for (
      const brand
      of calendarBrands()
    ) {
      const missing =
        engine.selections
          .missingCustomInputs({
            brand,
            profile,
            selections:
              state.calendarSelections[
                brand.brandId
              ]
          });

      if (missing.length) {
        return {
          valid: false,
          error:
            `Enter ${missing[0].label} for ${engine.helpers.formatDate(missing[0].date)}.`
        };
      }
    }

    if (!items.length) {
      return {
        valid: false,
        error:
          "Choose at least one calendar lunch item."
      };
    }

    if (
      items.some(
        item =>
          !Number.isFinite(
            Number(item.id)
          ) ||
          Number(item.id) <= 0
      )
    ) {
      return {
        valid: false,
        error:
          "One of the selected lunch items is not available. Please reselect it and try again."
      };
    }

    return {
      valid: true,
      items
    };
  }


  function clearCalendarSelections() {
    state.calendarSelections = {};

    renderCalendarOrdering();
  }


  function changeCalendarMain(
    brandId,
    date,
    item
  ) {
    const selections =
      engine.selections
        .setMain(
          calendarSelectionForBrand(
            brandId
          ),
          date,
          item
        );

    setCalendarSelection(
      brandId,
      selections
    );
    renderCalendarOrdering({ changedBrandId: brandId, changedDate: date });

  }


  function toggleCalendarAddOn(
    brandId,
    date,
    item
  ) {
    const selections =
      engine.selections
        .toggleAddOn(
          calendarSelectionForBrand(
            brandId
          ),
          date,
          item
        );

    setCalendarSelection(
      brandId,
      selections
    );

    renderCalendarOrdering({ changedBrandId: brandId, changedDate: date });
  }


  function toggleCalendarTopping(
    brandId,
    topping
  ) {
    const selections =
      engine.selections
        .toggleTopping(
          calendarSelectionForBrand(
            brandId
          ),
          topping
        );

    setCalendarSelection(
      brandId,
      selections
    );

    renderCalendarOrdering({ changedBrandId: brandId });
  }


  function changeCalendarOption(
    brandId,
    group,
    value
  ) {
    const selections =
      engine.selections
        .setOption(
          calendarSelectionForBrand(
            brandId
          ),
          group,
          value
        );

    setCalendarSelection(
      brandId,
      selections
    );

    renderCalendarOrdering({ changedBrandId: brandId });
  }


  function changeCalendarCustomInput(
    brandId,
    date,
    property,
    value
  ) {
    const selections =
      engine.selections
        .setCustomInput(
          calendarSelectionForBrand(
            brandId
          ),
          date,
          property,
          value
        );

    setCalendarSelection(
      brandId,
      selections
    );

    // No redraw is needed while typing; custom text does not change the price.
  }


  /* =========================================================
     CART VALIDATION
     ========================================================= */

  function validateOrder() {
    const school =
      currentSchool();

    const profile =
      currentProfile();

    const brand =
      currentBrand();

    if (!school) {
      return {
        valid: false,
        error:
          "Choose a school."
      };
    }

    if (!profile) {
      return {
        valid: false,
        error:
          "Choose who this order is for."
      };
    }

    if (!brand) {
      return {
        valid: false,
        error:
          "Choose a lunch program."
      };
    }

    const invalidDates = engine.selections.invalidDates({
      brand,
      profile,
      selections: state.selections
    });
    if (invalidDates.length) {
      return {
        valid: false,
        error: `The menu has changed for ${engine.helpers.formatDate(invalidDates[0])}. Please reselect your lunch.`
      };
    }

    const items =
      engine.cart.build({
        school,
        profile,
        brand,

        selections:
          state.selections,

        periodId:
        state.activePeriodId
      });

    const missing =
      engine.selections
        .missingCustomInputs({
          brand,
          profile,
          selections:
            state.selections
        });

    if (missing.length) {
      return {
        valid: false,
        error:
          `Enter ${missing[0].label} for ${engine.helpers.formatDate(missing[0].date)}.`
      };
    }

    if (!items.length) {
      return {
        valid: false,
        error:
          "Choose at least one lunch item."
      };
    }

    /*
      Safety check: every Shopify cart item
      must have a legitimate numeric variant ID.
    */

    if (
      items.some(
        item =>
          !Number.isFinite(
            Number(item.id)
          ) ||
          Number(item.id) <= 0
      )
    ) {
      return {
        valid: false,
        error:
          "One of the selected lunch items is not available. Please reselect it and try again."
      };
    }

    return {
      valid: true,
      items
    };
  }


  /* =========================================================
     ADD TO CART
     ========================================================= */

  async function addToCart() {
    if (state.cartBusy) {
      return;
    }

    ui.messages
      .clearCartError();

    const validation =
      validateOrder();

    if (!validation.valid) {
      ui.messages
        .cartError(
          validation.error
        );

      return;
    }

    state.cartBusy = true;

    renderSummary();

    try {
      await services.cart
        .add(
          validation.items
        );

      /*
        Go directly to Shopify cart after a
        successful multi-line add.
      */

      services.cart.go();

    } catch (error) {
      console.error(
        "BYL cart error:",
        error
      );

      ui.messages
        .cartError(
          friendlyError(
            error,
            "The order could not be added to your cart. Please try again."
          )
        );
    } finally {
      state.cartBusy = false;

      renderSummary();
    }
  }
  /* =========================================================
     CALENDAR ORDERING
     ========================================================= */

  function openCalendarOrdering() {
    const school =
      currentSchool();

    const profile =
      currentProfile();

    if (!school) {
      ui.messages.set(
        "Choose a school before opening Calendar Ordering.",
        "error"
      );

      return;
    }

    if (!profile) {
      ui.messages.set(
        "Choose who you're ordering for before opening Calendar Ordering.",
        "error"
      );

      return;
    }

    renderCalendarOrdering();

    const regular =
      document.getElementById(
        "byl-ordering"
      );

    const calendar =
      document.getElementById(
        "byl-calendar-order"
      );

    if (!calendar) {
      return;
    }

    if (regular) {
      regular.hidden = true;

      regular.classList.add(
        "hidden"
      );
    }

    calendar.hidden = false;

    calendar.classList.remove(
      "hidden"
    );

    calendar.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });

    Promise.all(
      calendarBrands()
        .map(
          brand =>
            engine.brands
              .preloadVariants(
                brand
              )
              .catch(error => {
                console.warn(
                  "BYL calendar variant preload:",
                  error
                );
              })
        )
    ).then(
      renderCalendarOrdering
    );
  }


  function closeCalendarOrdering() {
    const regular =
      document.getElementById(
        "byl-ordering"
      );

    const calendar =
      document.getElementById(
        "byl-calendar-order"
      );

    if (calendar) {
      calendar.hidden = true;

      calendar.classList.add(
        "hidden"
      );
    }

    if (regular) {
      regular.hidden = false;

      regular.classList.remove(
        "hidden"
      );

      regular.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  }


  async function submitCalendarOrder() {
    if (state.cartBusy) {
      return;
    }

    const validation =
      validateCalendarOrder();

    if (!validation.valid) {
      ui.messages.set(
        validation.error,
        "error"
      );

      return;
    }

    state.cartBusy = true;

    renderCalendarOrdering();

    try {
      await services.cart
        .add(
          validation.items
        );

      services.cart.go();

    } catch (error) {
      console.error(
        "BYL calendar cart error:",
        error
      );

      ui.messages.set(
        friendlyError(
          error,
          "The calendar order could not be added to your cart. Please try again."
        ),
        "error"
      );

    } finally {
      state.cartBusy = false;

      renderCalendarOrdering();
    }
  }

  /* =========================================================
     FRIENDLY ERRORS
     ========================================================= */

  function friendlyError(
    error,
    fallback
  ) {
    const message =
      clean(
        error?.message
      );

    if (
      !message ||
      /failed to fetch/i
        .test(message)
    ) {
      return fallback;
    }

    return message;
  }


  /* =========================================================
     UI CALLBACK CONFIGURATION
     ========================================================= */

  function configureUi() {
    ui.configure({
      onSchoolCode:
        unlockSchool,

      onSchoolChange:
        selectSchool,

      onAddSchool:
        openAddSchoolModal,

      onSchoolDelete:
        deleteSchool,

      onSchoolFavorite:
        favoriteSchool,

      onProfileSelect:
        selectProfile,

      onProfileEdit:
        openProfileEditor,
onProfileDelete:
  deleteProfile,

      onProfileSave:
        saveProfile,

      onProfileCancel:
  () => {},

onProfileHistoryDecision:
  saveProfileHistoryDecision,

onBrandSelect:
  selectBrand,

      onMainSelect:
        selectMain,

      onAddOnToggle:
        toggleAddOn,

      onToppingToggle:
        toggleTopping,

      onOptionChange:
        changeOption,

      onCustomInputChange:
        changeCustomInput,

      onPeriodChange:
        changePeriod,

      onPeriodChoice:
        changePeriodChoice,

      onOrderAnyway:
        allowExistingOrder,

      onCopyDateForward:
        copyDateForward,

           onAddToCart:
        addToCart,

      onCalendarOpen:
        openCalendarOrdering,

      onCalendarClose:
        closeCalendarOrdering,

      onCalendarClear:
        clearCalendarSelections,

      onCalendarSubmit:
        submitCalendarOrder,

      onCalendarChange:
        payload => {
          if (
            payload?.type ===
            "main"
          ) {
            changeCalendarMain(
              payload.brandId,
              payload.date,
              payload.item
            );

          } else if (
            payload?.type ===
            "addon"
          ) {
            toggleCalendarAddOn(
              payload.brandId,
              payload.date,
              payload.item
            );

          } else if (
            payload?.type ===
            "topping"
          ) {
            toggleCalendarTopping(
              payload.brandId,
              payload.value
            );

          } else if (
            payload?.type ===
            "option"
          ) {
            changeCalendarOption(
              payload.brandId,
              payload.group,
              payload.value
            );
          } else if (
            payload?.type ===
            "customInput"
          ) {
            changeCalendarCustomInput(
              payload.brandId,
              payload.date,
              payload.property,
              payload.value
            );
          }
        }
    });
  }


  /* =========================================================
     INITIALIZATION
     ========================================================= */

  async function init() {

    setupOrderHistory();

    if (state.initialized) {
      return;
    }

    state.initialized =
      true;

    configureUi();
    initializeHistory();

    /*
      Process OAuth callback before doing the
      rest of the page setup.
    */

    await handleCustomerAuth();

    await restoreSchools();

    const pendingState =
      readPendingState();

    /*
      Pick a school.
    */

const savedSchools =
  isLoggedInCustomer()
    ? customer.schools
        .initial()
    : null;

const defaultSchoolId =
  clean(
    savedSchools
      ?.defaultSchoolId
  ) ||
  clean(
    services.schools
      .defaultStored?.()
  );

state.favoriteSchoolId =
  defaultSchoolId;

if (
  pendingState
    ?.currentSchoolId &&
  findSchoolEntry(
    pendingState
      .currentSchoolId
  )
) {
  state.currentSchoolId =
    pendingState
      .currentSchoolId;

} else if (
  defaultSchoolId &&
  findSchoolEntry(
    defaultSchoolId
  )
) {
  state.currentSchoolId =
    defaultSchoolId;

} else if (
  state.schools.length
) {
  state.currentSchoolId =
    state.schools[0]
      .school
      .schoolId;

  state.favoriteSchoolId =
    state.favoriteSchoolId ||
    state.currentSchoolId;
}

    if (
      !state.currentSchoolId
    ) {
      ui.school.showGate();
      return;
    }

    rebuildProfiles();

    /*
      Restore profile/brand/order state after
      Customer Account OAuth.
    */

    if (pendingState) {
      restorePendingState(
        pendingState
      );
    }

    renderAll();

    /*
      If OAuth was started specifically because
      a logged-in customer saved a profile,
      finish that save now.
    */

    if (
      readPendingProfile() &&
      customer.auth
        .isAuthenticated()
    ) {
      await finishPendingProfileSave();
    }
    if (
  readPendingProfileDelete() &&
  customer.auth
    .isAuthenticated()
) {
  await finishPendingProfileDelete();
}
if (
  readPendingHistoryDecision() &&
  customer.auth
    .isAuthenticated()
) {
  await finishPendingHistoryDecision();
}
    if (
  isLoggedInCustomer() &&
  customer.auth
    .isAuthenticated()
) {
  await syncVerifiedSchoolsToCustomer();
}
  }


  /* =========================================================
     DEBUG API
     ========================================================= */

  BYL.core = {
    init,

    state,

    get: {
      school:
        currentSchool,

      profile:
        currentProfile,

      brand:
        currentBrand
    },

    render:
      renderAll,

    debug: {
      rebuildProfiles,
      validateOrder,
      readGuestProfiles,
      readPendingState,
      readPendingProfile
    }
  };


  /* =========================================================
     START
     ========================================================= */

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      init,
      {
        once: true
      }
    );
  } else {
    init();
  }

})();
